import React, {useEffect} from 'react';
import {observer, useLocalObservable, inject} from "mobx-react";
import {runInAction, toJS} from "mobx";
import PropTypes from "prop-types";
import FormField from "../../Helpers/FormField";
import {input} from "../../../utils/linker";

function Select(props) {
  const store = useLocalObservable(() => ({list: [], fetching: false, inited: false}));
  useEffect(() => {
    // mount

    return () => {
      // unmount
    }
  }, []);


  if(!props.linker.value && props.option.default) {
    runInAction(()=>{
      props.linker.value=props.option.default;
    });
  }

  return (
    <FormField title={props.option.name} description={props.option.description}>
      <span className="seleect"><select {...input(props.linker, "value")}>
        {props.option.options.map((item, ind)=>{
          return (
            <option key={item.id} value={item.id}>{item.name}</option>
          )
        })}
      </select></span>
    </FormField>
  )
};

Select.defaultProps = {};

Select.propTypes = {}

export default observer(Select);
